module.exports = __webpack_public_path__ + "img/天力保温杯.7c5fdf49.png";